/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { useFlux, useLayoutEffect, withMemo } from 'fierry/react.old';

import Rpc from 'shared/alias/rpc';

import * as Auth from 'shared/util/auth';


export default withMemo( (props) =>
{
  const [ rpc ] = useFlux(Rpc);

  useLayoutEffect(() =>
  {
    Auth.getInstance().reset();
    Auth.getInstance().start('#firebase-auth-container', Auth.getDefaultConfig(rpc));
  }, []);

  return <div id = 'firebase-auth-container' />;
});
